import request from '@/utils/request'

export const Sorgula = (pageNo= 1, q = "", osmanlicaMiAriyor = false, pageSize = 100) => {
    return request({
        url: 'LatinceOsmanlica/Sorgula',
        params: {
            pageNo,
            q,
            osmanlicaMiAriyor,
            pageSize
        }
    })
}
